// Developed by Aptus Engineering, Inc. <https://aptusai.com>
// See LICENSE.md file in project root directory

export default (user) => user ? user.enableDarkMode : window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

// export default (user) => false; 